import {
    MORNING_BRIEFING_START_HOUR,
    MORNING_BRIEFING_END_HOUR,
    EVENING_BRIEFING_START_HOUR,
    EVENING_BRIEFING_END_HOUR,
} from './constants';
import { userDate, getHours } from 'owa-datetime';

/**
 * Checks if current time is within the morning briefing window.
 * @returns true if current hour is between the morning briefing hours
 */
export function isMorningBriefing(): boolean {
    const now = userDate();
    const hour = getHours(now);
    return hour >= MORNING_BRIEFING_START_HOUR && hour <= MORNING_BRIEFING_END_HOUR;
}

/**
 * Checks if current time is within the evening briefing window
 * @returns true if current hour is between the evening briefing hours
 */
export function isEveningBriefing(): boolean {
    const now = userDate();
    const hour = getHours(now);
    return hour >= EVENING_BRIEFING_START_HOUR && hour <= EVENING_BRIEFING_END_HOUR;
}
